(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kaffee-kaufbox"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      if (!document.querySelector('[data-kb-aktiv]')) return;
      var bar = document.querySelector('.product-form__button--fixed');
      var main = document.querySelector('.product-form__item__button-submit [data-add-to-cart]:not(.product-form__cart-submit--fixed)');
      if (!bar || !main) return;
      var ticking = false;
      function update() {
        ticking = false;
        var below = main.getBoundingClientRect().top >= window.innerHeight;
        if (below && window.scrollY > 80) { bar.setAttribute('data-kb-show', ''); } else { bar.removeAttribute('data-kb-show'); }
      }
      function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', request, { passive: true });
      window.addEventListener('resize', request);
      update();
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kaffee-steckbrief"] && !Shopify.designMode) return;
  try {
    /* Webstra: Akkordeon "Beschreibung" standardmäßig aufgeklappt.
     Das Theme misst die Akkordeons beim Initialisieren und schließt sie dabei –
     danach wird "Beschreibung" wieder geöffnet, solange der Kunde es nicht selbst angeklickt hat. */
  (function () {
    function ksOpen() {
      document.querySelectorAll('details.product__collapsible-details').forEach(function (d) {
        var s = d.querySelector('summary');
        if (!s || !/^\s*Beschreibung\s*$/i.test(s.textContent) || d.dataset.ksOpened) return;
        d.dataset.ksOpened = '1';
        var touched = false;
        s.addEventListener('click', function () { touched = true; });
        function open() {
          if (touched || d.open) return;
          d.open = true;
          s.setAttribute('aria-expanded', 'true');
        }
        open();
        var mo = new MutationObserver(function () {
          if (!touched && !d.open && (d.getAttribute('style') || '').indexOf('--collapsed') > -1) { open(); mo.disconnect(); }
        });
        mo.observe(d, { attributes: true, attributeFilter: ['style', 'open'] });
        setTimeout(function () { mo.disconnect(); }, 20000);
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', ksOpen); } else { ksOpen(); }
  })();
  } catch(e) { console.error(e); }
})();

})();
